import { Injectable} from '@angular/core';
import {Floor} from './floor.model';
import {CrudService} from '@ngx-ivengi/crud';

@Injectable()
export class FloorService extends CrudService<Floor> {
  public entityType = Floor;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/floor/floor.service.ts